import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/back.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-09240a13")

_pushScopeId("data-v-09240a13")
const _hoisted_1 = { class: "shell padding-top24px" }
const _hoisted_2 = { class: "back-text" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "margin-right5px",
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "pay-content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_step = _resolveComponent("el-step")
  const _component_el_steps = _resolveComponent("el-steps")
  const _component_choose_type = _resolveComponent("choose-type")
  const _component_purchase_detail = _resolveComponent("purchase-detail")
  const _component_information = _resolveComponent("information")
  const _component_processing = _resolveComponent("processing")
  const _component_pay_success = _resolveComponent("pay-success")
  const _component_auto_renew_success = _resolveComponent("auto-renew-success")
  const _component_auto_renew_failed = _resolveComponent("auto-renew-failed")
  const _component_pay_failed = _resolveComponent("pay-failed")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.activeStep!==0 && _ctx.activeStep<3&&_ctx.step==='process')
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "margin-bottom40px  margin-left40px",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.backStep && _ctx.backStep(...args)))
        }, [
          _createVNode("b", _hoisted_2, [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(`${_ctx.$wordList.ProperAllTextBack}`), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.step==='process')
      ? (_openBlock(), _createBlock(_component_el_steps, {
          key: 1,
          active: _ctx.activeStep,
          class: "step-padding"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_step, {
              title: _ctx.$wordList.ProperAllTextPurchaseTypes
            }, null, 8, ["title"]),
            _createVNode(_component_el_step, {
              title: _ctx.$wordList.OrderPurchaseDetails
            }, null, 8, ["title"]),
            _createVNode(_component_el_step, {
              title: _ctx.$wordList.OrderPaymentInformation
            }, null, 8, ["title"]),
            _createVNode(_component_el_step, {
              title: _ctx.$wordList.OrderConfirmation
            }, null, 8, ["title"])
          ]),
          _: 1
        }, 8, ["active"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_4, [
      (_ctx.step==='autoPayInfo')
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.autoPayInfoComponents[_ctx.userType]), {
            key: 0,
            data: _ctx.autoPayItemData,
            "is-batch": _ctx.isBatch,
            lastStep: _ctx.lastStep,
            "user-type": _ctx.userType,
            onChangeStep: _ctx.changeStepHandler
          }, null, 8, ["data", "is-batch", "lastStep", "user-type", "onChangeStep"]))
        : (_ctx.step==='process')
          ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              (_ctx.activeStep === 0)
                ? (_openBlock(), _createBlock(_component_choose_type, {
                    key: 0,
                    onClick: _ctx.setType,
                    userType: _ctx.userType,
                    "project-id": _ctx.projectId,
                    onChangeStep: _ctx.changeStepHandler
                  }, null, 8, ["onClick", "userType", "project-id", "onChangeStep"]))
                : (_ctx.activeStep === 1)
                  ? (_openBlock(), _createBlock(_component_purchase_detail, {
                      key: 1,
                      "subscription-type": _ctx.subscriptionType,
                      "project-id": _ctx.projectId,
                      "is-batch": _ctx.isBatch,
                      "user-type": _ctx.userType,
                      onClearInitPurchaseDetailsData: _cache[2] || (_cache[2] = ($event: any) => (_ctx.initPurchaseDetailsDataTemp={})),
                      initPurchaseDetailsData: _ctx.initPurchaseDetailsDataTemp,
                      onSureDetail: _ctx.setInfo
                    }, null, 8, ["subscription-type", "project-id", "is-batch", "user-type", "initPurchaseDetailsData", "onSureDetail"]))
                  : (_ctx.activeStep === 2)
                    ? (_openBlock(), _createBlock(_component_information, {
                        key: 2,
                        "subscription-type": _ctx.subscriptionType,
                        "is-batch": _ctx.isBatch,
                        "user-type": _ctx.userType,
                        info: _ctx.info,
                        onPay: _ctx.createOrder
                      }, null, 8, ["subscription-type", "is-batch", "user-type", "info", "onPay"]))
                    : (_ctx.activeStep === 3)
                      ? (_openBlock(), _createBlock(_component_processing, {
                          key: 3,
                          onSuccess: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setActiveStep(4))),
                          onFailed: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setActiveStep(5))),
                          "pay-jump-url": _ctx.payJump,
                          title: _ctx.isAutoRenew?`${_ctx.$wordList.Submitting}...`:_ctx.$wordList.ProperAllTextPayProgressing,
                          jumpTips: _ctx.isAutoRenew?_ctx.$wordList.AutoPayProcessingTips:_ctx.$wordList.ProperAllTextPayJump
                        }, null, 8, ["pay-jump-url", "title", "jumpTips"]))
                      : (_ctx.activeStep === 4)
                        ? (_openBlock(), _createBlock(_component_pay_success, {
                            key: 4,
                            onInvoice: _ctx.invoice
                          }, null, 8, ["onInvoice"]))
                        : (_ctx.activeStep===6)
                          ? (_openBlock(), _createBlock(_component_auto_renew_success, { key: 5 }))
                          : (_ctx.activeStep===7)
                            ? (_openBlock(), _createBlock(_component_auto_renew_failed, { key: 6 }))
                            : (_openBlock(), _createBlock(_component_pay_failed, { key: 7 }))
            ], 64))
          : _createCommentVNode("", true)
    ])
  ]))
})